import AccordionWrapper from './AccordionWrapper';

export default AccordionWrapper;
